var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'onboarding-tool-preview': true }},[_c('div',{ref:"inner",staticClass:"onboarding-tool-preview__inner onboarding-tool-preview__inner--reserve-space-right"},[_c('TemplatePreview',{attrs:{"template":_vm.template}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }